import { render, staticRenderFns } from "./edit_role.vue?vue&type=template&id=d51b42a2&scoped=true"
import script from "./edit_role.vue?vue&type=script&lang=js"
export * from "./edit_role.vue?vue&type=script&lang=js"
import style0 from "./edit_role.vue?vue&type=style&index=0&id=d51b42a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51b42a2",
  null
  
)

export default component.exports